import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { handleApiError } from "../handleApiError";
import { getAuthToken } from "../../utils/auth";

const API_URL = process.env.REACT_APP_API_URL;
const CONTACT_URL = `${API_URL}/contact-us`;

/* =========================
   SEND CONTACT (Public)
========================= */
export const sendContact = createAsyncThunk(
  "contact/send",
  async (data, { rejectWithValue }) => {
    try {
      const token = getAuthToken();

      const res = await axios.post(
        CONTACT_URL,
        data,
        token
          ? {
              headers: { Authorization: `${token}` },
            }
          : {},
      );

      return res.data;
    } catch (err) {
      handleApiError(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

/* =========================
   GET ALL CONTACTS (Admin)
========================= */
export const getAllContactsAdmin = createAsyncThunk(
  "contact/getAllAdmin",
  async (params, { rejectWithValue }) => {
    try {
      const token = getAuthToken();

      const res = await axios.get(CONTACT_URL, {
        params,
        ...(token && {
          headers: { Authorization: `${token}` },
        }),
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

/* =========================
   DELETE CONTACT (Admin)
========================= */
export const adminDeleteContact = createAsyncThunk(
  "contact/delete",
  async (contactId, { rejectWithValue }) => {
    try {
      const token = getAuthToken();

      await axios.delete(`${CONTACT_URL}/${contactId}`, {
        ...(token && {
          headers: { Authorization: `${token}` },
        }),
      });

      return contactId;
    } catch (err) {
      handleApiError(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);
